document.addEventListener('DOMContentLoaded', function () {
    var filterDrawer = document.getElementById('wt-filters-drawer');
    var openButton = document.querySelector('[data-open-filters]');
    var closeButton = filterDrawer ? filterDrawer.querySelector('.wt-filter__close') : null;

    if (filterDrawer && openButton && closeButton) {
      // Open drawer
      openButton.addEventListener('click', function () {
        filterDrawer.classList.add('wt-filter--drawer-open');
        filterDrawer.setAttribute('aria-hidden', 'false');
        closeButton.focus();
      });

      // Close drawer
      closeButton.addEventListener('click', function () {
        filterDrawer.classList.remove('wt-filter--drawer-open');
        filterDrawer.setAttribute('aria-hidden', 'true');
        openButton.focus();
      });
    }
  });